import { useEffect, useState } from "react";
import { ArrowLeft } from "lucide-react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { CameraReader } from "@/pages/rrhh/Scan";
import { cachedGet } from "./offline";
import { Pick } from "@/pages/gerencia/Sales";


export const beep = (ok = true) => {
  try {
    const ctx = new (window.AudioContext || window.webkitAudioContext)();
    const o = ctx.createOscillator();
    const g = ctx.createGain();
    o.frequency.value = ok ? 1046 : 220;
    g.gain.value = 0.15;
    o.connect(g); g.connect(ctx.destination);
    o.start(); o.stop(ctx.currentTime + (ok ? 0.12 : 0.35));
    navigator.vibrate?.(ok ? 60 : [80, 60, 80]);
  } catch { /* sin audio */ }
};

export const Screen = ({ title, children, testid }) => (
  <div data-testid={testid} className="space-y-4">
    <div className="flex items-center gap-2">
      <Link to="/terreno" data-testid="terreno-back-btn" className="rounded-full bg-white border border-[#e4e8e1] p-2 active:scale-95"><ArrowLeft size={20} /></Link>
      <h1 className="text-xl font-extrabold">{title}</h1>
    </div>
    {children}
  </div>
);

export const Card = ({ children, className = "", ...rest }) => <div {...rest} className={`rounded-2xl bg-white border border-[#e4e8e1] p-4 ${className}`}>{children}</div>;

export const Toggle = ({ value, onChange, options, testid }) => (
  <div className="grid grid-cols-2 gap-3" data-testid={testid}>
    {options.map(([k, label, Icon]) => (
      <button key={k} type="button" data-testid={`${testid}-${k}`} onClick={() => onChange(k)}
        className={`flex items-center justify-center gap-2 rounded-2xl border-2 py-5 text-lg font-extrabold active:scale-95 transition-transform ${value === k ? "bg-[#258F00] border-[#258F00] text-white" : "bg-white border-[#e4e8e1] text-[#5b6656]"}`}>
        <Icon size={22} />{label}
      </button>))}
  </div>
);

export const useOts = (url, map = (d) => d) => {
  const [ots, setOts] = useState([]);
  useEffect(() => { cachedGet(url).then((d) => setOts(map(d))).catch(() => {}); }, [url]); // eslint-disable-line react-hooks/exhaustive-deps
  return ots;
};

export const OtSelect = ({ ots, value, onChange, testid }) => (
  <Pick testid={testid} value={value} onChange={(v) => { localStorage.setItem("terreno_ot", v); onChange(v); }} options={ots} placeholder="Seleccione la OT" />
);

export const savedOt = () => localStorage.getItem("terreno_ot") || "";

export const ScanBox = ({ onRead, placeholder = "O escriba el RUT / código y presione Ir", testid = "terreno-scan" }) => {
  const [t, setT] = useState("");
  return (
    <div className="space-y-2" data-testid={testid}>
      <div className="max-h-[260px] overflow-hidden rounded-xl"><CameraReader onRead={onRead} /></div>
      <form className="flex gap-2" onSubmit={(e) => { e.preventDefault(); if (t.trim()) { onRead(t.trim()); setT(""); } }}>
        <Input data-testid={`${testid}-input`} className="h-11" placeholder={placeholder} value={t} onChange={(e) => setT(e.target.value)} />
        <Button data-testid={`${testid}-submit`} className="h-11 rounded-full">Ir</Button>
      </form>
    </div>
  );
};
